(() => {
    const forms = document.querySelectorAll("[data-site-search-form]");
    if (!forms.length) {
        return;
    }

    forms.forEach((form) => {
        const input = form.querySelector("[data-site-search-input]");
        const suggestBox = form.querySelector("[data-site-search-suggest]");

        if (!input || !suggestBox) {
            return;
        }

        let debounceTimer = null;
        let lastQuery = "";
        let lastController = null;

        const setExpanded = () => {
            const shouldExpand =
                input === document.activeElement || input.value.trim().length > 0;
            form.classList.toggle("header-site-search--expanded", shouldExpand);
        };

        const clearSuggest = () => {
            suggestBox.innerHTML = "";
            suggestBox.classList.remove("is-open");
        };

        const renderSuggest = (items) => {
            if (!items || !items.length) {
                clearSuggest();
                return;
            }

            suggestBox.innerHTML = "";

            items.forEach((item) => {
                const link = document.createElement("a");
                link.className = "header-site-search__item";

                let uri = String(item.uri || "");
                while (uri.startsWith("/")) {
                    uri = uri.slice(1);
                }
                link.href = "/" + uri;

                const label = document.createElement("span");
                label.className = "header-site-search__label";
                label.textContent = item.label || "";

                const title = document.createElement("span");
                title.className = "header-site-search__title";
                title.textContent = item.title || "";

                link.appendChild(label);
                link.appendChild(title);
                suggestBox.appendChild(link);
            });

            suggestBox.classList.add("is-open");
        };

        const fetchSuggest = (query) => {
            if (lastController) {
                lastController.abort();
            }
            lastController = new AbortController();

            fetch(`/search/suggest?q=${encodeURIComponent(query)}`, {
                signal: lastController.signal,
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Suggest error");
                    }
                    return response.json();
                })
                .then((data) => {
                    renderSuggest(data.items || []);
                })
                .catch(() => {
                    clearSuggest();
                });
        };

        input.addEventListener("input", () => {
            const query = input.value.trim();
            setExpanded();

            if (query.length < 2) {
                lastQuery = query;
                clearSuggest();
                return;
            }

            if (query === lastQuery) {
                return;
            }

            lastQuery = query;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                fetchSuggest(query);
            }, 200);
        });

        input.addEventListener("focus", () => {
            setExpanded();
            const query = input.value.trim();
            if (query.length >= 2 && suggestBox.childElementCount > 0) {
                suggestBox.classList.add("is-open");
            }
        });

        input.addEventListener("blur", () => {
            setTimeout(() => {
                setExpanded();
            }, 120);
        });

        document.addEventListener("click", (event) => {
            if (!form.contains(event.target)) {
                clearSuggest();
            }
        });

        setExpanded();
    });
})();
